import React from 'react';
import Table from '../common/Table';
import { SubRegionDTO } from '../../services/apiClient';

interface SubRegionTableProps {
  data: (SubRegionDTO & { stateName?: string })[];
  handleEdit: (row: SubRegionDTO) => void;
  handleDelete: (row: SubRegionDTO) => void;
  isLoading: boolean;
}

const SubRegionTable: React.FC<SubRegionTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        { label: 'Name', key: 'name' },
        { label: 'Code', key: 'code' },
        { label: 'State', key: 'stateName' },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      allowPaging={false}
      isLoading={isLoading}
      noDataMessage="No sub regions added yet"
    />
  );
};

export default SubRegionTable;
